import {GET_TOP_ENTITY_METADATA, UPDATE_TOP_ENTITY_METADATA} from '../../actions/actiontypes';
import initialstate from '../initialstate';
import {HttpStatusCodes} from '../../util/uiconstants';

export default function topHeaderReducer(state = initialstate.topHeader, action) {
	switch (action.type) {
		case GET_TOP_ENTITY_METADATA:
			if (action.response && action.responseObj.status === HttpStatusCodes.Ok) {
				return {
					...state,
					entityMetadata: action.mapper(action.response)
				};
			}
			return state;
		case UPDATE_TOP_ENTITY_METADATA:
			return {
				...state,
				entityMetadata: action.mapper(action.payload)
			};
		default:
			return state;
	}
}
